module.exports = __webpack_public_path__ + "img/avatar-jeremy-pennycook.6348cf17.jpg";